/**
 * 一个干净的 COS 实例
 */

import user from '@/scripts/helper/user';
import COS from '@/plugins/cos_sdk/src/cos';

// 实例化 COS
const cos = new COS({
  Protocol: 'https:',
  UploadCheckContentMd5: true,
  ChunkSize: 1024 * 1024 * 8,
  SliceSize: 1024 * 1024 * 8,
  CopyChunkSize: 1024 * 1024 * 8,
  CopySliceSize: 1024 * 1024 * 8,
  UserAgent: window.navigator.userAgent,
  getAuthorization(options, callback) {
    user.getCredential().then(credential => {
      const SecretId = credential.SecretId || credential.tmpSecretId;
      const SecretKey = credential.SecretKey || credential.tmpSecretKey;
      options = { ...options, SecretId, SecretKey };
      const res = { Authorization: COS.getAuthorization(options) };
      if (credential.token) {
        res.SecurityToken = credential.token;
      }
      callback(res);
    });
  },
});

export default cos;
